import React from 'react';
import { makeStyles } from '@mui/styles';
import { Close as CloseIcon, Menu as MenuIcon } from '@mui/icons-material';
import Anchor from '../shared/anchor';
import { Button, SwipeableDrawer } from '@mui/material';

const useStyles = makeStyles({
  paper: {
    borderRadius: '0px 10px 10px 0px',
  },

  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function NavbarSwipeableDrawer(props) {
  const { toggleDrawer, open } = props;

  const classes = useStyles();
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <>
      <Anchor onClick={toggleDrawer(true)} className={'drawer-trigger-container ' + props.className}>
        <MenuIcon className="drawer-trigger-icon" />
      </Anchor>
      <SwipeableDrawer
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        classes={{ paper: classes.paper }}
        className={'drawer-nav ' + props.className}
      >
        <Button className="close" onClick={toggleDrawer(false)}>
          <CloseIcon />
        </Button>
        {props.children}
      </SwipeableDrawer>
    </>
  );
}
